import { render, staticRenderFns } from "./inbook_publication.vue?vue&type=template&id=974c6112"
import script from "./inbook_publication.vue?vue&type=script&lang=js"
export * from "./inbook_publication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports